import { createActionCreator } from '../../utils/helpers';

import { userById } from './types';

export const requestUserById = createActionCreator(userById.request, 'id');
export const requestUserByIdSuccess = createActionCreator(userById.success, 'response');
export const requestUserByIdFailure = createActionCreator(userById.failure, 'error');
